/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ConfigureSettingsType = "MeetingColors" | "PersonalCalendarSync" | "SettingUpTeam" | "SettingUpWorkingHours" | "ShadowCalendar" | "SlackStatusSync" | "TravelTime" | "%future added value";
export type SuggestionActionConfigSettings_payload = {
    readonly configureSettingsType: ConfigureSettingsType | null;
    readonly " $refType": "SuggestionActionConfigSettings_payload";
};
export type SuggestionActionConfigSettings_payload$data = SuggestionActionConfigSettings_payload;
export type SuggestionActionConfigSettings_payload$key = {
    readonly " $data"?: SuggestionActionConfigSettings_payload$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SuggestionActionConfigSettings_payload">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SuggestionActionConfigSettings_payload",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "configureSettingsType",
            "storageKey": null
        }
    ],
    "type": "SuggestionActionConfigureSettingsPayload",
    "abstractKey": null
} as any;
(node as any).hash = '6da45684ea28a20082ee6f125121e363';
export default node;
